module.exports = __webpack_public_path__ + "7b53c6cc6e415b359a17178ef9f5a775.png";